import { Button, Dialog, DialogContent, List as MUIList } from '@mui/material';
import SvgIconStyle from '@components/SvgIconStyle';
import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { styles } from './styles';
import DialogTitle from '../dialog-title';
import ListItem from './list-item';
import { DialogListJSONAPI } from '~/api/resources/dialog_list';

type Props = {
  open: boolean;
  onClose: () => void;
  agentLists: DialogListJSONAPI[];
  active: string | undefined;
  onClickList: (id: string, listId: string) => void;
  setActive: (newValue: string | undefined) => void;
  openCreateListDialog: () => void;
};

const AddToListDialog: FC<Props> = (props) => {
  const { open, onClose, openCreateListDialog, onClickList, active, agentLists } = props;
  const { t } = useLocales();

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle onClose={onClose} title={t('dashboard.search.results.add_to_list.title')} />
      <DialogContent dividers sx={styles.dialogContent}>
        <Button
          variant="text"
          size="large"
          color="primary"
          sx={styles.createNewButton}
          startIcon={<SvgIconStyle src="/icons/iconly/light/plus.svg" sx={styles.plusIcon} />}
          onClick={openCreateListDialog}
        >
          {t('dashboard.search.results.add_to_list.create_new')}
        </Button>
        <MUIList>
          {agentLists?.map((list) => (
            <ListItem key={list.id} list={list} active={active} setActive={onClickList} />
          ))}
        </MUIList>
      </DialogContent>
    </Dialog>
  );
};

export default AddToListDialog;
